import React from "react";
import { useTranslation } from "react-i18next";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ChannelIcon } from "./ChannelBadge";
import type { ChannelFilterValue } from "./InboxProvider";

const FILTERS: { value: ChannelFilterValue; labelKey: string; fallback: string }[] = [
	{ value: "all", labelKey: "inbox.filters.all", fallback: "All" },
	{ value: "email", labelKey: "inbox.filters.email", fallback: "Email" },
	{ value: "linkedin", labelKey: "inbox.filters.linkedin", fallback: "LinkedIn" },
	{ value: "whatsapp", labelKey: "inbox.filters.whatsapp", fallback: "WhatsApp" },
];

/** Segmented channel filter: All | Email | LinkedIn | WhatsApp. */
export const ChannelFilter: React.FC<{
	value: ChannelFilterValue;
	onChange: (value: ChannelFilterValue) => void;
}> = ({ value, onChange }) => {
	const { t } = useTranslation();

	return (
		<ToggleGroup
			type="single"
			value={value}
			onValueChange={(next) => onChange((next as ChannelFilterValue) || "all")}
			className="w-full justify-start gap-1"
		>
			{FILTERS.map((filter) => {
				const label = t(filter.labelKey, filter.fallback);
				return (
					<Tooltip key={filter.value}>
						<TooltipTrigger asChild>
							<ToggleGroupItem
								value={filter.value}
								aria-label={label}
								className="h-8 flex-1 gap-1.5 rounded-sm border border-transparent px-2 text-xs font-medium text-muted-foreground data-[state=on]:border-border data-[state=on]:bg-accent data-[state=on]:text-foreground"
							>
								{filter.value === "all" ? (
									<span>{label}</span>
								) : (
									<ChannelIcon channel={filter.value} className="h-3.5 w-3.5" />
								)}
							</ToggleGroupItem>
						</TooltipTrigger>
						<TooltipContent side="bottom">{label}</TooltipContent>
					</Tooltip>
				);
			})}
		</ToggleGroup>
	);
};
